import {Component, CUSTOM_ELEMENTS_SCHEMA, ElementRef, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {MyBusiness} from '../../models/my-business';
import {GlobalLoaderService} from '../../services/global-loader.service';
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule} from '@angular/forms';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {EnvironmentService} from '../../services/environment.service';
import {ApiAgentService} from '../../services/api-agent.service';
import {InvoiceThemes} from '../../models/invoice-themes';
import {FontInterface} from 'ngx-font-picker';
import {first, firstValueFrom} from 'rxjs';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';

declare var Snackbar: any;
declare var Pickr: any;
declare var $: any;


@Component({
  selector: 'app-theme-settings',
  templateUrl: './theme-settings.component.html',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, TranslateModule, RouterModule],
  styleUrls: ['./theme-settings.component.scss']
})
export class ThemeSettingsComponent implements OnInit {
  loading: boolean;
  myBusiness: MyBusiness;
  form: FormGroup;
  invoiceThemes: InvoiceThemes;
  submitted: boolean;
  submitting: boolean;
  @ViewChild('primaryColor') primaryColor: ElementRef;
  @ViewChild('secondaryColor') secondaryColor: ElementRef;
  @ViewChild('footerColor') footerColor: ElementRef;
  @ViewChild('footerBackgroundColor') footerBackgroundColor: ElementRef;
  @ViewChild('primaryLightColor') primaryLightColor: ElementRef;
  @ViewChild('primaryHoverColor') primaryHoverColor: ElementRef;
  @ViewChild('textColor') textColor: ElementRef;
  @ViewChild('menuTextColor') menuTextColor: ElementRef;
  @ViewChild('buttonHoverTextColor') buttonHoverTextColor: ElementRef;
  @ViewChild('progressModalBackground') progressModalBackground: ElementRef;
  @ViewChild('backgroundColor') backgroundColor: ElementRef;
  @ViewChild('foregroundColor') foregroundColor: ElementRef;
  @ViewChild('titlePanelBackground') titlePanelBackground: ElementRef;
  @ViewChild('paymentFormBackground') paymentFormBackground: ElementRef;
  @ViewChild('buttonTextColor') buttonTextColor: ElementRef;

  @ViewChild('paymentDeclineColor') paymentDeclineColor: ElementRef;
  @ViewChild('paymentApprovedColor') paymentApprovedColor: ElementRef;
  @ViewChild('invoiceHeaderTextColor') invoiceHeaderTextColor: ElementRef;

  defaultFont: FontInterface;

  constructor(private formBuilder: FormBuilder,
              private translate: TranslateService,
              private loader: GlobalLoaderService,
              private env: EnvironmentService,
              private api: ApiAgentService) {
  }

  async ngOnInit() {
    this.form = this.formBuilder.group({
      primaryColor: [''],
      secondaryColor: [''],
      footerColor: [''],
      footerBackgroundColor: [''],
      primaryLightColor: [''],
      primaryHoverColor: [''],
      showLogo: ['paylink'],
      showPaymentMethods: ['yes'],
      hideClientAddress: ['no'],
      textColor: [''],
      menuTextColor: [''],
      buttonHoverTextColor: [''],
      fontUrl: [''],
      fontFamily: [''],
      backgroundColor: [''],
      foregroundColor: [''],
      progressModalBackground: [''],
      hideInvoiceSummery: ['no'],
      hideVatInvoice: ['no'],
      defaultLanguage: ['ar'],
      titlePanelBackground: [''],
      paymentFormBackground: [''],
      buttonTextColor: [''],
      paymentDeclineColor: [''],
      paymentApprovedColor: [''],
      invoiceHeaderTextColor: [''],
    });

    this.defaultFont = {family: 'Cairo', size: '12', style: 'Regular'};

    await this.load();
    await this.loadResources();
    await this.loadColorsPicker('primaryColor', this.primaryColor.nativeElement, this.invoiceThemes != null && this.invoiceThemes.primaryColor != null ? this.invoiceThemes.primaryColor : '#FFF');
    await this.loadColorsPicker('secondaryColor', this.secondaryColor.nativeElement, this.invoiceThemes != null && this.invoiceThemes.secondaryColor != null ? this.invoiceThemes.secondaryColor : '#8C60E2');
    await this.loadColorsPicker('footerColor', this.footerColor.nativeElement, this.invoiceThemes != null && this.invoiceThemes.footerColor != null ? this.invoiceThemes.footerColor : '#f2f0f5');
    await this.loadColorsPicker('footerBackgroundColor', this.footerBackgroundColor.nativeElement, this.invoiceThemes != null && this.invoiceThemes.footerBackgroundColor != null ? this.invoiceThemes.footerBackgroundColor : '#110f15');
    await this.loadColorsPicker('primaryLightColor', this.primaryLightColor.nativeElement, this.invoiceThemes != null && this.invoiceThemes.primaryLightColor != null ? this.invoiceThemes.primaryLightColor : '#FFF');
    await this.loadColorsPicker('primaryHoverColor', this.primaryHoverColor.nativeElement, this.invoiceThemes != null && this.invoiceThemes.primaryHoverColor != null ? this.invoiceThemes.primaryHoverColor : '#FFF');
    await this.loadColorsPicker('textColor', this.textColor.nativeElement, this.invoiceThemes != null && this.invoiceThemes.textColor != null ? this.invoiceThemes.textColor : '#FFF');
    await this.loadColorsPicker('menuTextColor', this.menuTextColor.nativeElement, this.invoiceThemes != null && this.invoiceThemes.menuTextColor != null ? this.invoiceThemes.menuTextColor : '#FFF');
    await this.loadColorsPicker('buttonHoverTextColor', this.buttonHoverTextColor.nativeElement, this.invoiceThemes != null && this.invoiceThemes.buttonHoverTextColor != null ? this.invoiceThemes.buttonHoverTextColor : '#FFF');
    await this.loadColorsPicker('progressModalBackground', this.progressModalBackground.nativeElement, this.invoiceThemes != null && this.invoiceThemes.progressModalBackground != null ? this.invoiceThemes.progressModalBackground : '#FFF');
    await this.loadColorsPicker('backgroundColor', this.backgroundColor.nativeElement, this.invoiceThemes != null && this.invoiceThemes.backgroundColor != null ? this.invoiceThemes.backgroundColor : '#FFF');
    await this.loadColorsPicker('foregroundColor', this.foregroundColor.nativeElement, this.invoiceThemes != null && this.invoiceThemes.foregroundColor != null ? this.invoiceThemes.backgroundColor : '#FFF');
    await this.loadColorsPicker('titlePanelBackground', this.titlePanelBackground.nativeElement, this.invoiceThemes != null && this.invoiceThemes.titlePanelBackground != null ? this.invoiceThemes.titlePanelBackground : '#FFF');
    await this.loadColorsPicker('paymentFormBackground', this.paymentFormBackground.nativeElement, this.invoiceThemes != null && this.invoiceThemes.paymentFormBackground != null ? this.invoiceThemes.paymentFormBackground : '#FFF');

    await this.loadColorsPicker('buttonTextColor', this.buttonTextColor.nativeElement, this.invoiceThemes != null && this.invoiceThemes.buttonTextColor != null ? this.invoiceThemes.buttonTextColor : '#FFF');
    await this.loadColorsPicker('paymentDeclineColor', this.paymentDeclineColor.nativeElement, this.invoiceThemes != null && this.invoiceThemes.paymentDeclineColor != null ? this.invoiceThemes.paymentDeclineColor : '#ffc107');
    await this.loadColorsPicker('paymentApprovedColor', this.paymentApprovedColor.nativeElement, this.invoiceThemes != null && this.invoiceThemes.paymentApprovedColor ? this.invoiceThemes.paymentApprovedColor : '#ffc107');
    await this.loadColorsPicker('invoiceHeaderTextColor', this.invoiceHeaderTextColor.nativeElement, this.invoiceThemes != null && this.invoiceThemes.invoiceHeaderTextColor ? this.invoiceThemes.invoiceHeaderTextColor : '#FFF');
  }

  async loadColorsPicker(fieldName, nativeElement, defaultColor) {
    const picker = Pickr.create({
      el: nativeElement,
      theme: 'monolith', // 'classic' or 'monolith', or 'nano'
      useAsButton: true,
      comparison: false,
      default: defaultColor,
      swatches: [
        'rgba(244, 67, 54, 1)',
        'rgba(233, 30, 99, 1)',
        'rgba(156, 39, 176, 1)',
        'rgba(103, 58, 183, 1)',
        'rgba(63, 81, 181, 1)',
        'rgba(33, 150, 243, 1)',
        'rgba(3, 169, 244, 1)',
        'rgba(0, 188, 212, 1)',
        'rgba(0, 150, 136, 1)',
        'rgba(76, 175, 80, 1)',
        'rgba(139, 195, 74, 1)',
        'rgba(205, 220, 57, 1)',
        'rgba(255, 235, 59, 1)',
        'rgba(255, 193, 7, 1)'
      ],
      components: {
        preview: true,
        opacity: true,
        hue: true,
        interaction: {
          hex: true,
          rgba: false,
          hsla: false,
          hsva: false,
          cmyk: false,
          input: true,
          clear: false,
          save: false
        }
      }
    });
    picker.on('change', (color, source, instance) => {

      this.v[fieldName] = color.toHEXA().toString();
      this.invoiceThemes[fieldName] = color.toHEXA().toString();
      this.form.patchValue({
        [fieldName]: color.toHEXA().toString()
      });
      nativeElement.value = color.toHEXA().toString().replace('#', '');
      nativeElement.style = 'text-alight: left;';
      instance.setColor('#' + nativeElement.value, true);
      let pickerColor = nativeElement.parentNode.getElementsByClassName('picker-color');
      Array.from(pickerColor).forEach((element: any) => element.style = 'background: ' + color.toHEXA() + ';width:100%;height:100%');
    });
  }

  async loadResources() {
    await this.loader.loadExternalStyles('/plugins/notification/snackbar/snackbar.min.css');
    await this.loader.loadExternalScript('/plugins/notification/snackbar/snackbar.min.js');
    await this.loader.loadExternalStyles('https://cdn.jsdelivr.net/npm/@simonwep/pickr/dist/themes/classic.min.css');
    await this.loader.loadExternalStyles('https://cdn.jsdelivr.net/npm/@simonwep/pickr/dist/themes/monolith.min.css');
    await this.loader.loadExternalStyles('https://cdn.jsdelivr.net/npm/@simonwep/pickr/dist/themes/nano.min.css');
    await this.loader.loadExternalScript('https://cdn.jsdelivr.net/npm/@simonwep/pickr/dist/pickr.min.js');
    await this.loader.loadExternalScript('https://cdn.jsdelivr.net/npm/@simonwep/pickr/dist/pickr.es5.min.js');
  }

  async load() {
    this.loading = true;
    try {
      this.myBusiness = await this.api.getMyBusiness(false);
    } catch (ex) {
    }

    try {
      this.invoiceThemes = await this.api.getMyInvoiceThemes();

      this.form.patchValue({
        primaryColor: this.invoiceThemes.primaryColor,
        secondaryColor: this.invoiceThemes.secondaryColor,
        footerColor: this.invoiceThemes.footerColor,
        footerBackgroundColor: this.invoiceThemes.footerBackgroundColor,
        primaryLightColor: this.invoiceThemes.primaryLightColor,
        primaryHoverColor: this.invoiceThemes.primaryHoverColor,
        textColor: this.invoiceThemes.textColor,
        menuTextColor: this.invoiceThemes.menuTextColor != null ? this.invoiceThemes.menuTextColor : '#FFF',
        showLogo: this.invoiceThemes.showLogo != null ? this.invoiceThemes.showLogo : 'paylink',
        showPaymentMethods: this.invoiceThemes.showPaymentMethods ? 'yes' : 'no',
        hideClientAddress: this.invoiceThemes.hideClientAddress ? 'yes' : 'no',
        buttonHoverTextColor: this.invoiceThemes.buttonHoverTextColor,
        fontUrl: this.invoiceThemes.fontUrl,
        fontFamily: this.invoiceThemes.fontFamily,
        defaultLanguage: this.invoiceThemes.defaultLanguage,
        backgroundColor: this.invoiceThemes.backgroundColor,
        foregroundColor: this.invoiceThemes.foregroundColor,
        progressModalBackground: this.invoiceThemes.progressModalBackground,
        hideInvoiceSummery: this.invoiceThemes.hideInvoiceSummery ? 'yes' : 'no',
        hideVatInvoice: this.invoiceThemes.hideVatInvoice ? 'yes' : 'no',
        titlePanelBackground: this.invoiceThemes.titlePanelBackground,
        paymentFormBackground: this.invoiceThemes.paymentFormBackground,
        buttonTextColor: this.invoiceThemes.buttonTextColor != null ? this.invoiceThemes.buttonTextColor : '#FFF',
        paymentDeclineColor: this.invoiceThemes.paymentDeclineColor != null ? this.invoiceThemes.paymentDeclineColor : '#ffc107',
        paymentApprovedColor: this.invoiceThemes.paymentApprovedColor != null ? this.invoiceThemes.paymentApprovedColor : '#44781a',
        invoiceHeaderTextColor: this.invoiceThemes.invoiceHeaderTextColor != null ? this.invoiceThemes.invoiceHeaderTextColor : '#FFF',
      });
    } catch (ex) {
      console.log('ex', ex);
    } finally {
      this.loading = false;
    }
  }

  // @ts-ignore
  get f() {
    return this.form.controls;
  }

  // @ts-ignore
  get v() {
    return this.form.value;
  }

  async resetForm() {
    this.invoiceThemes = await this.api.getDefaultInvoiceThemes();
    this.form.patchValue({
      primaryColor: this.invoiceThemes.primaryColor,
      secondaryColor: this.invoiceThemes.secondaryColor,
      footerColor: this.invoiceThemes.footerColor,
      footerBackgroundColor: this.invoiceThemes.footerBackgroundColor,
      primaryLightColor: this.invoiceThemes.primaryLightColor,
      primaryHoverColor: this.invoiceThemes.primaryHoverColor,
      textColor: this.invoiceThemes.textColor,
      menuTextColor: this.invoiceThemes.menuTextColor,
      showLogo: this.invoiceThemes.showLogo != null ? this.invoiceThemes.showLogo : 'paylink',
      showPaymentMethods: this.invoiceThemes.showPaymentMethods ? 'yes' : 'no',
      hideClientAddress: this.invoiceThemes.hideClientAddress ? 'yes' : 'no',
      buttonHoverTextColor: this.invoiceThemes.buttonHoverTextColor,
      fontUrl: this.invoiceThemes.fontUrl,
      fontFamily: this.invoiceThemes.fontFamily,
      progressModalBackground: this.invoiceThemes.progressModalBackground,
      defaultLanguage: this.invoiceThemes.defaultLanguage,
      backgroundColor: this.invoiceThemes.backgroundColor,
      foregroundColor: this.invoiceThemes.foregroundColor,
      hideInvoiceSummery: this.invoiceThemes.hideInvoiceSummery ? 'yes' : 'no',
      hideVatInvoice: this.invoiceThemes.hideVatInvoice ? 'yes' : 'no',
      titlePanelBackground: this.invoiceThemes.titlePanelBackground,
      paymentFormBackground: this.invoiceThemes.paymentFormBackground,
      buttonTextColor: this.invoiceThemes.buttonTextColor,
      paymentDeclineColor: this.invoiceThemes.paymentDeclineColor,
      paymentApprovedColor: this.invoiceThemes.paymentApprovedColor,
      invoiceHeaderTextColor: this.invoiceThemes.invoiceHeaderTextColor,
    });
  }

  async submitForm() {
    this.submitted = true;
    if (this.form.valid) {
      this.submitting = true;
      try {
        await this.api.postMyInvoiceThemes({
          primaryColor: this.v['primaryColor'],
          secondaryColor: this.v['secondaryColor'],
          footerColor: this.v['footerColor'],
          footerBackgroundColor: this.v['footerBackgroundColor'],
          primaryLightColor: this.v['primaryLightColor'],
          primaryHoverColor: this.v['primaryHoverColor'],
          showLogo: this.v['showLogo'],
          showPaymentMethods: this.v['showPaymentMethods'] == 'yes',
          hideClientAddress: this.v['hideClientAddress'] == 'yes',
          textColor: this.v['textColor'],
          menuTextColor: this.v['menuTextColor'],
          buttonHoverTextColor: this.v['buttonHoverTextColor'],
          fontUrl: this.v['fontUrl'],
          fontFamily: this.v['fontFamily'],
          backgroundColor: this.v['backgroundColor'],
          foregroundColor: this.v['foregroundColor'],
          progressModalBackground: this.v['progressModalBackground'],
          hideInvoiceSummery: this.v['hideInvoiceSummery'] == 'yes',
          hideVatInvoice: this.v['hideVatInvoice'] == 'yes',
          titlePanelBackground: this.v['titlePanelBackground'],
          paymentFormBackground: this.v['paymentFormBackground'],
          defaultLanguage: this.v['defaultLanguage'],
          buttonTextColor: this.v['buttonTextColor'],
          paymentDeclineColor: this.v['paymentDeclineColor'],
          paymentApprovedColor: this.v['paymentApprovedColor'],
          invoiceHeaderTextColor: this.v['invoiceHeaderTextColor'],
        });
        ThemeSettingsComponent.showToast(await firstValueFrom(this.translate.get('My settings saved successfully')));
      } catch (ex) {
        console.log('Submit Form Error', ex);
        if (ex.error.title) {
          ThemeSettingsComponent.showToast(await firstValueFrom(this.translate.get(ex.error.title)));
        } else {
          ThemeSettingsComponent.showToast(await firstValueFrom(this.translate.get('Could not save my setting. Try again')));
        }
      } finally {
        this.submitting = false;
        this.submitted = false;
      }
    }
  }

  private static showToast(msg) {
    Snackbar.show({
      text: msg,
      pos: 'bottom-center'
    });
  }

  loadStyle() {
    return 'width: 35px;border-top-right-radius: 5px;border-bottom-right-radius: 5px;padding: 5px;border: 1px solid #bfc9d4;';
  }

  loadStyleColor(fieldColor: string) {
    let color = this.v[fieldColor] != null ? this.v[fieldColor] : '#FFF';
    return 'background: ' + color + ';width:100%;height:100%';
  }

  handleFontChange(fontInterface) {
    console.log('font', fontInterface);
    this.form.patchValue({
      fontUrl: 'https://fonts.googleapis.com/icon?family=' + fontInterface.family, // fontInterface.files[fontInterface.style],
      fontFamily: fontInterface.family,
    });
  }

  async createDemoInvoice() {
    let order: any = await this.api.getDemoInvoiceUrl();
    window.open(order.url);
  }
}
